const IMG_PROXY = process.env.NEXT_PUBLIC_IMAGE_PROXY;

const FALLBACK_IMAGE =
  "https://assets.sesamy.com/static/images/sesamy/sesamy-simple.svg";

export const getImgProxyUrl = (imgPath: string | null, props?: string[]) => {
  const path = imgPath || FALLBACK_IMAGE;

  // Need to replace some chars to make it URL-safe
  const base64 = Buffer.from(path)
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

  return `${IMG_PROXY}/unsafe/${props ? props.join("/") + "/" : ""}${base64}`;
};
